import * as network from './network'
import * as comps from './comps'

export default { network, comps }
